<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg">

  <ng-container *ngIf="consulta">
    <ul class="card-list-striped py-1">
      <li>
        <span class="text-secondary">CNPJ:</span>
        <span class="text-uppercase">{{ consulta?.cnpj || msgNull }} </span>
      </li>
      <li>
        <span class="text-secondary">SITUAÇÃO DO CNPJ:</span>
        <span class="text-uppercase">
          {{ consulta?.situacao_cnpj || msgNull }}
          {{ consulta?.emissao_situacao_cnpj != 'Sem detalhamento' ? ' em ' + consulta?.emissao_situacao_cnpj : '' }}
        </span>
      </li>
      <li>
        <span class="text-secondary">RAZÃO SOCIAL:</span>
        <span class="text-uppercase">{{ consulta?.razao_social || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">NATUREZA JURÍDICA:</span>
        <span class="text-uppercase">{{ consulta?.natureza_juridica || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">DATA DA FUNDAÇÃO:</span>
        <span class="text-uppercase">{{ consulta?.data_fundacao || msgNull }}</span>
      </li>
      <!--parte unificada-->
      <li>
        <span class="text-secondary">NOME FANTASIA:</span>
        <span class="text-uppercase">{{ consulta?.nome_fantasia || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">INSCRIÇÃO ESTADUAL:</span>
        <span class="text-uppercase">{{ consulta?.inscricao_estadual || msgNull }}</span>
      </li>
      <li *ngIf="consulta?.exportacao">
        <span class="text-secondary">% EXPORTAÇÃO:</span>
        <span class="text-uppercase">{{ consulta?.exportacao || msgNull }}</span>
      </li>
      <li *ngIf="consulta?.importacao">
        <span class="text-secondary">% IMPORTAÇÃO:</span>
        <span class="text-uppercase">{{ consulta?.importacao || msgNull }}</span>
      </li>
      <li *ngIf="consulta?.opcaoTributaria || consulta?.opcao_tributaria">
        <span class="text-secondary">OPÇÃO TRIBUTÁRIA:</span>
        <span class="text-uppercase">{{ consulta?.opcaoTributaria || consulta?.opcao_tributaria || msgNull }}</span>
      </li>

    </ul>
    <h2 class="subtitle">ATIVIDADE ECONÔMICA PRINCIPAL</h2>
    <div class="d-flex col-12 p-0 px-2 p-1">
      <span class="text-secondary">DESCRIÇÃO: </span>
      <span class="text-uppercase px-2">{{ consulta?.atividadeEconomicaPrincipal || consulta?.ativ_econ_principal || consulta?.atividade_economica_principal || msgNull }}</span>
    </div>
    <ng-container *ngIf="consulta?.atividadeEconomicaSecundaria?.length">
      <h2 class="subtitle">ATIVIDADE(S) ECONÔMICA(S) SECUNDÁRIA</h2>
      <!--div class="d-flex d-lg-flex col-12 p-1 px-2"
        *ngFor="let a of consulta?.atividadeEconomicaSecundaria; let i = index">
        <div class="col-0">
          <span class="text-secondary">{{ a.cnae }}</span>
        </div>
        <div class="col-10 px-3">
          <span class="text-uppercase">{{ a.descricao || msgNull }}</span>
        </div>
      </div>-->


      <table class="table table-striped table-responsive-sm table-sm w-100 card-list-striped">
        <thead class="fw-500 text-info font-weight-bold">
            <th class="px-2">CNAE</th>
            <th class="px-2">DESCRIÇÃO</th>
        </thead>
        <tbody>
            <tr *ngFor="let a of consulta?.atividadeEconomicaSecundaria">
                <td class="px-2 text-uppercase">{{ a?.cnae || msgNull }}</td>
                <td class="px-2 text-uppercase">{{ a?.descricao || msgNull }}</td>
            </tr>
        </tbody>
    </table>
    </ng-container>
    
  </ng-container>
</app-card-consulta>